<div class="container">
    <app-price-table></app-price-table>
</div>